import React, { useContext, useEffect, useMemo, useState } from "react";
import { Typography, theme } from "antd";
import { knownAllergiesOptions } from "../../../Options/historyOptions";
import CheckListFBYInput from "../../../../../blocks/FormItems/CheckListFBYInput";
import { hexToRgba } from "../../../../../helpers/utility";
const KnownAllergies = ({ context, form }) => {
  const { token } = theme.useToken();
  const { formData } = useContext(context);
  const historyData = formData?.history || formData;

  const initialValues = useMemo(() => historyData, [historyData]);
  const [checkboxes, setCheckboxes] = useState({});

  useEffect(() => {
    const initialCheckboxes = knownAllergiesOptions.reduce((acc, checkbox) => {
      acc[checkbox.value] = initialValues?.[checkbox.value] || false; // Initialize all checkboxes based on initialValues
      return acc;
    }, {});
    setCheckboxes(initialCheckboxes);
  }, [initialValues]);

  return (
    <>
      <Typography>Known Allergies</Typography>
      <div
        className="subsection-card"
        style={{
          borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
          background: "transparent",
          marginTop: "8px",
        }}
      >
        <CheckListFBYInput
          options={knownAllergiesOptions}
          checkboxes={checkboxes}
          setCheckboxes={setCheckboxes}
          others_key={"others"}
          form={form}
          field_key={"known_allergies_others"}
        />
      </div>
    </>
  );
};

export default KnownAllergies;
